import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_CONTRACTORS } from "../../../utils/constants";
import contractorService from "../../../services/ticketService/contractorService";
import { ContractorInterface } from "../../../models/TicketModule/Contractor";

const useContractorById = (id: string) =>
  useQuery<ContractorInterface, Error>({
    queryKey: [`${CACHE_KEY_CONTRACTORS}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, contractorId] = queryKey;
      return contractorService.GetById(contractorId as string);
    },
    enabled: !!id,
  });

export default useContractorById;
